// extracted by mini-css-extract-plugin
export default {"Container":"Banner_Container__qAmEK","rotate":"Banner_rotate__vioMQ","text":"Banner_text__zo-j1","line":"Banner_line__pPFNT","header__content":"Banner_header__content__wi9l6"};